module.exports = __webpack_public_path__ + "img/skypets-5.543e723c.webp";